import logo from './logo.svg';
import './App.css';
import Test from './componend/test'
import { createTheme, ThemeProvider } from '@mui/material';

//maeteriaulcomponint
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import CloudIcon from '@mui/icons-material/Cloud';
// axios
import axios from 'axios';
// useEffect
import { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment/moment';//هاذا حق الوقت و التاريخ 

const theme = createTheme({
  typography: {
    fontFamily: ("fontC")//حق الخط يجي جاهز من الموقع
  }
})
function App() {
  const dateandtime = moment().format('MMM/ Do/ YYYY/, h:mm:ss a');

  const secon = moment().format();
  console.log("the time is" + dateandtime)
  const [temp, settemp] = useState({
    number: null,
    main: null,
    discribin: "",
    max: null,
    icon: null,
  })
  useEffect(() => {
    console.log("text")


    // Make a request for a user with a given ID
    axios
      .get(
        'https://api.openweathermap.org/data/2.5/weather?lat=44.34&lon=10.99&appid=c793f73dc3a53090d09ef8b6e447c913'
      )
      .then(function (response) {
        <div>
          {/* // handle success
        // console.log("data",response.data);
        // console.log("data.main",response.data.main.temp -272.15); */}
        </div>
        const responsetemp = Math.round(response.data.main.temp - 272.15)// Math.roundبدونكسور  mapتطلع السيسيديور بدون كسور تطلع ال
        const tempmax = response.data.main.temp_max;
        const tempmin = response.data.main.temp_min;
        const descripsion = response.data.weather[0].description;
        const responseicon = response.data.weather[0].icon;

        console.log(response.data)
        console.log("number", responsetemp, "tempmax", tempmax, "tempmin", tempmin, "descripsion", descripsion);
        settemp({
          number: responsetemp,
          max: tempmax,
          main: tempmin,
          discribin: descripsion,
          icon: ` https://openweathermap.org/img/wn/${responseicon}@2x.png`,
        });

      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });


  }, []);
  return (

    <div className="App">
      <Container maxWidth="sm" style={{
        // backgroundColor:"green"
      }}>
        {/* <h1 maxWidth="sm" style={{backgroundColor:"green"}}>hree</h1> */}
        <div
          style={{
            height: "100vh",
            // background:"gold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center ",
            flexDirection: "column"
          }}
        >
          {/* card */}
          <div
            dir='rtl'
            style={{
              backgroundColor: "#052b35",
              color: "white ",
              borderRadius: "15px",
              padding: "10px",
              boxShadow: "0px 11px 1px rgba(0.0.0.0.05)"
            }}>

            {/* cuontent */}

            <div >
              <div>
                {/* city & time */}
                <div style={{
                  display: "flex",
                  direction: "rtl",
                  alignItems: "end",
                  justifyContent: "start",

                }}>
                  <Typography variant="h1" gutterBottom style={{ marginRight: "20px", fontWeight: "600" }} >
                    الرياض
                  </Typography>
                  <Typography variant="h5" gutterBottom style={{ marginRight: "20px" }}  >
                    {dateandtime}
                  </Typography>
                </div>
                <hr />

                {/* city & time */}
                {/* temp */}

                <div>
                  <div style={{ display: "flex", justifyContent: "space-around" }}>

                    <Typography variant="h1" gutterBottom style={{ marginRight: "20px", textAlign: "right" }}  >
                      {temp.number}
                    </Typography>

                    {/* imge.tem */}
                    {/* <div></div> */}
                    {/* imge.tem */}
                    <img
                      src=
                      {temp.icon}

                    />
                  </div>
                  {/* temp */}

                  <Typography variant="h6 " gutterBottom   >
                    {temp.discribin}
                  </Typography>
                  {/* main & max */}

                  <div>

                    <h5>درجه الحراره الصغرى :{temp.max}</h5>
                    <h5>درجه الحراره الكبرى :{temp.main}</h5>

                  </div>



                  {/* degre & descripsion */}
                  <div>
                    <CloudIcon
                      style=
                      {{
                        fontSize: "200px",
                        color: "white",
                      }}

                    />

                  </div>


                </div>
              </div>
              {/* ugre & descripsion */}

            </div>
            {/* cuontent */}

          </div>

          {/* card */}
        </div>


      </Container>
       <marquee direction="right" scrollamount="10">
        <h1>Yahya Ahhmd Alhaifi ...... Tell:+967 771940086 ...... Email:yahayaalhaifi@gmail.com</h1>
       </marquee>
      <ThemeProvider theme={theme}>
        {/* <Test/> */}
      </ThemeProvider>

    </div>
  );
}

export default App;
